import GA4 from './GA4';


export default GA4;

  